import { useLocation } from "react-router-dom";

const useMessage = () => {
  // Query string is available through the Router context via useLocation
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  // Additional translation logic to go here.
  // TBA: Compute translated message, type (i.e., warning, error etc.).
  const messageId = params.get("msgId");

  // Default as error message until translation logic added
  return messageId || "";
};

export default useMessage;
